import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'
export default {
    path: '/skillsLabel',
    name: 'SkillsLabel',
    meta: {
        title: '技能管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/skillsLabel/skillsLabelIndex',
    children: [{
            path: 'skillsLabelIndex',
            name: 'SkillsLabelIndex',
            meta: {
                title: '技能列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/skillsLabel/skillsLabel/Index.vue'], resolve),
        },
        {
            path: 'skillsLabelIndex',
            name: 'skillsLabelIndex',
            meta: {
                title: '技能列表',
                keepAlive: true
            },
            component: Empty,
            children: [{
                    path: 'skillsLableAdd',
                    name: 'SkillsLableAdd',
                    meta: {
                        title: '编辑技能',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/skillsLabel/skillsLabel/SkillsLableAdd.vue'], resolve),
                },
                {
                    path: 'skillsLableAdd',
                    name: 'skillsLableAdd',
                    component: Empty,
                    meta: {
                        title: '编辑技能',
                        keepAlive: false
                    },
                    children: [{
                        path: '/skillsLabel/skillsLabelIndex/skillsLableAdd/AtomicClassDetail',
                        name: 'AtomicClassDetailskil',
                        meta: {
                            title: '预览原子课',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/atomicClasses/atomicClasses/AtomicClassDetail.vue'], resolve)

                    }, {
                        path: '/skillsLabel/skillsLabelIndex/skillsLableAdd/courPackgeDetail',
                        name: 'CourPackgeDetailskil',
                        meta: {
                            title: '预览课程包',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/coursePackage/coursePackage/CourPackgeDetail.vue'], resolve),
                    },  ]
                }, {
                    path: 'skillsLablEdit',
                    name: 'SkillsLablEdit',
                    meta: {
                        title: '编辑技能',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/skillsLabel/skillsLabel/SkillsLableAdd.vue'], resolve),
                }
            ]
        }
    ]
}